import { Outlet } from "react-router"

// Studio sub-tabs now live in the Material Compliance header nav
// (MaterialComplianceNav); this layout just frames the active page.
export function SupplierStudioLayout() {
  return (
    <div className="flex h-full flex-col overflow-hidden">
      {/* This wrapper is THE scroll container for every studio page: padding
          sits inside it, so the scrollbar hugs the pane edge at any window
          width instead of floating 24px inboard next to a page that scrolls
          on its own. Pages that split-scroll internally (InquiryPage) keep
          their h-full box and are unaffected. */}
      <div className="min-h-0 flex-1 overflow-y-auto px-6 pb-6 pt-4">
        <Outlet />
      </div>
    </div>
  )
}
